var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChefIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.9983 19.1646C53.7081 18.928 54.6545 18.928 55.6009 18.928C62.6988 18.928 68.6138 24.843 68.6138 31.941C68.6138 39.039 62.6988 44.954 55.6009 44.954L56.7838 66.2479H18.9279L20.1109 44.954C13.0129 44.954 7.0979 39.039 7.0979 31.941C7.0979 24.843 13.0129 18.928 20.1109 18.928C21.0573 18.928 22.0037 18.928 22.7135 19.1646",
    stroke: "#FCFCFC",
    strokeOpacity: 0.98,
    strokeWidth: 4.732,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M54.4179 26.026C54.4179 16.7986 47.0833 9.46399 37.8559 9.46399C28.6285 9.46399 21.2939 16.7986 21.2939 26.026",
    stroke: "#FCFCFC",
    strokeOpacity: 0.98,
    strokeWidth: 4.732,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.856 49.6859V56.7839",
    stroke: "#FCFCFC",
    strokeOpacity: 0.98,
    strokeWidth: 4.732,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.575 49.6859L28.392 56.0741",
    stroke: "#FCFCFC",
    strokeOpacity: 0.98,
    strokeWidth: 4.732,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1368 49.6859L47.3198 56.0741",
    stroke: "#FCFCFC",
    strokeOpacity: 0.98,
    strokeWidth: 4.732,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChefIcon);
export default __webpack_public_path__ + "static/media/chefIcon.15a703aec1e9c9e05804422daa8b52ea.svg";
export { ForwardRef as ReactComponent };